import { LoadingButton } from '@olxbr/ds-core'
import { Alertbox } from '@olxbr/ds-web'
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { ResponsiveModal } from '../../organisms/ResponsiveModal'
import { breakpoints } from '../../../util/medias'
import useWindowSize from '../../../util/useWindowSize'
import Lock from '@olxbr/olx-icons/dist/System/Lock'

const StyledButton = styled(LoadingButton)`
  margin-top: var(--spacing-2);
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    margin-bottom: var(--spacing-1);
  }
  @media screen and (min-width: ${breakpoints['mobile'] + 1}px) {
    margin-left: var(--spacing-1);
  }
`

const StyledText = styled.span.attrs({ className: 'typo-body-medium' })`
  @media screen and (max-width: ${breakpoints['mobile']}px) {
    font-size: var(--font-size-1-75);
  }
`

export const ConfirmPhoneNumberModal = ({ onConfirm, closeModal, isOpen, isSubmitting, phone }) => {
  const { isMobile } = useWindowSize()
  return (
    <ResponsiveModal
      isOpen={isOpen}
      closeModal={closeModal}
      renderButtons={
        <React.Fragment>
          <StyledButton
            aria-label="Confirmar telefone"
            onClick={onConfirm}
            className={isMobile ? 'w-full' : undefined}
            isLoading={isSubmitting}
            disabled={isSubmitting}
            size="medium"
          >
            Confirmar
          </StyledButton>
          <StyledButton
            variant="link"
            className={isMobile ? 'w-full' : undefined}
            onClick={closeModal}
            disabled={isSubmitting}
            size="medium"
          >
            Alterar número
          </StyledButton>
        </React.Fragment>
      }
    >
      <span className="typo-title-small mb-1">{phone}</span>
      <span className="typo-body-medium mb-4">Confirme se você digitou o número corretamente.</span>
      <div className="flex flex-col">
        <div className="flex mb-1 mt-1">
          <Alertbox>
            <StyledText className="font-semibold">
              O mesmo número de telefone não pode ser usado em mais de uma conta OLX.
            </StyledText>
          </Alertbox>
        </div>
        <Alertbox icon={<Lock />}>
          <StyledText className="font-semibold">
            Seu número não será exibido para outros usuários.
          </StyledText>
        </Alertbox>
      </div>
    </ResponsiveModal>
  )
}

ConfirmPhoneNumberModal.propTypes = {
  onConfirm: PropTypes.func,
  isOpen: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  closeModal: PropTypes.func,
  phone: PropTypes.string,
}
